// packages/sdk/errors/src/errors.ts
var BaseError = class extends Error {
  constructor(code, message, context) {
    super(message ? `${code}: ${message}` : code.toString());
    this.code = code;
    this.context = context;
    Object.setPrototypeOf(this, new.target.prototype);
  }
};
var ApiError = class extends BaseError {
};
var SystemError = class extends BaseError {
};
var CancelledError = class extends SystemError {
  constructor(message, context) {
    super("CANCELLED", message, context);
  }
};
var InvalidConfigError = class extends ApiError {
  constructor(message, context) {
    super("INVALID_CONFIG", message, context);
  }
};
var RemoteServiceConnectionTimeout = class extends ApiError {
  constructor(message, context) {
    super("REMOTE_SERVICE_CONNECTION_TIMEOUT", message, context);
  }
};
export {
  ApiError,
  CancelledError,
  InvalidConfigError,
  RemoteServiceConnectionTimeout,
  SystemError
};
//# sourceMappingURL=index.mjs.map
